import { ZAttrMeta } from "src/business/attribute";
import { ZMfNode } from "src/components/MForm/ZMfNode";

let idCounter = 0;

const attr = (
  name: string,
  title: string,
): Pick<ZAttrMeta, "displayId" | "name" | "title" | "uid"> => {
  const displayId = ++idCounter;
  return {
    displayId,
    uid: String(displayId).padStart(5, "0"),
    name,
    title,
  };
};

export const mFormDemoMeta: ZMfNode = {
  type: "vertNav",
  useNavBar: true,
  nodes: [
    {
      type: "group",
      name: "ms",
      title: "Main Spec",
      content: {
        node: {
          type: "grid",
          nodes: [
            {
              type: "attr",
              attr: {
                ...attr("first", "First"),
                type: { name: "string" },
                required: true,
              },
            },
            {
              type: "attr",
              attr: {
                ...attr("massUnit", "Единицы массы"),
                type: { name: "strOption" },
                required: true,
                edit: {
                  component: {
                    type: "Select",
                    options: {
                      type: "inline",
                      list: [
                        { id: "g", label: "гр" },
                        { id: "kg", label: "кг" },
                        { id: "t", label: "т." },
                      ],
                    },
                  },
                },
              },
            },
            {
              type: "attr",
              attr: {
                ...attr("mass", "Масса"),
                type: { name: "number", precision: 2 },
                edit: {
                  component: {
                    type: "InputNumber",
                    addonAfter: "{{@massUnit:label}}",
                  },
                  rules: [
                    { type: "min", minValue: 0 },
                    {
                      type: "max",
                      maxValue: 100,
                      msg: "Не должно превышать 100",
                    },
                  ],
                },
              },
              disableIf: {
                type: "fieldValue",
                path: "@massUnit",
                op: "!=",
                value: "kg",
              },
            },
            {
              type: "attr",
              attr: {
                type: { name: "string", maxLength: 12 },
                ...attr("inn", "ИНН физлица"),
                edit: {
                  rules: [
                    {
                      type: "pattern",
                      pattern: "/\\d{12}/",
                      msg: "Требуется 12 цифр",
                    },
                  ],
                },
              },
            },
            {
              type: "attr",
              attr: {
                type: { name: "boolean" },
                ...attr("taskChecked", "Задача выполнена"),
                edit: {
                  component: {
                    type: "Switch",
                    checkedText: "Выполнено",
                    uncheckedText: "Не выполнено",
                  },
                },
              },
            },
            {
              type: "attr",
              attr: {
                type: { name: "strOption" },
                ...attr("selectModal", "Select Modal"),
                required: true,
                edit: {
                  component: {
                    type: "SelectValuesModal",
                    valuesCatalogId: "aeda237b-5fa7-4cff-b1c3-dd32cde2aa6a",
                    labelTemplate: "{{label}}",
                  },
                },
              },
            },
            {
              type: "grid",
              nodes: [
                {
                  type: "attr",
                  attr: {
                    type: { name: "number", precision: 0 },
                    ...attr("grade", "Оценка качества"),
                    required: true,
                  },
                },
                {
                  type: "attr",
                  attr: {
                    type: { name: "string" },
                    ...attr("completeNode", "Примечание к окончанию"),
                  },
                },
              ],
              hideIf: {
                type: "boolField",
                path: "ms.taskChecked",
                inv: true,
              },
            },
            {
              type: "attr",
              attr: {
                ...attr("documents", "Документы"),
                type: {
                  name: "list",
                  maxCount: 3,
                  fields: [
                    {
                      type: { name: "string" },
                      ...attr("docTitle", "Название документа"),
                      required: true,
                    },
                  ],
                },
              },
            },
            {
              type: "attr",
              attr: {
                ...attr("contracts", "Контракты"),
                type: {
                  name: "list",
                  fields: [
                    {
                      ...attr("contractName", "Название контракта"),
                      type: { name: "string" },
                      // required: true,
                    },
                    {
                      ...attr("startDate", "Дата начала"),
                      type: { name: "dateTime", dateOnly: true },
                      edit: {
                        component: {
                          type: "DatePicker",
                          suffix: "[{{ms.first}}]",
                        },
                      },
                    },
                    {
                      ...attr("contacts", "Контакты"),
                      type: {
                        name: "list",
                        fields: [
                          {
                            ...attr("fio", "ФИО"),
                            type: { name: "string" },
                          },
                          {
                            ...attr("phone", "Телефон"),
                            type: { name: "string" },
                          },
                          {
                            ...attr("email", "E-mail"),
                            type: { name: "string" },
                            edit: {
                              rules: [{ type: "email" }],
                              component: { type: "Input" },
                            },
                          },
                        ],
                      },
                    },
                  ],
                },
              },
            },
          ],
        },
      },
    },
  ],
};
